import { useEffect, useState } from "react";
import { matchMediaMobileIa } from "@orb-labs/orby-react/bullrun";

/**
 * Returns true when the viewport matches the mobile IA router cutoff (≤768px).
 *
 * Subscribes to `matchMedia` change events so resizing the browser flips the
 * value immediately. The initial value is resolved synchronously from
 * `matchMedia` so the first render already picks the right branch and avoids
 * a desktop-flash on mobile devices.
 */
export function useIsMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(matchMediaMobileIa).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia(matchMediaMobileIa);
    const handler = (event: MediaQueryListEvent) => setIsMobile(event.matches);
    setIsMobile(mql.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
